import { LOCALES } from "@marketplace/i18n";

export const personlaProfileFormI18n = {
    [LOCALES.ENG]: {
        developer_personal_page_personal_profile_first_name: 'First Name',
        developer_personal_page_personal_profile_last_name: 'Last Name',
        developer_personal_page_personal_profile_country_isd: 'Country',
        developer_personal_page_personal_profile_phone: 'Phone',
        developer_personal_page_personal_profile_email: 'Email',
        developer_personal_page_personal_change_password: 'Change password',
        developer_personal_page_personal_profile_password: 'New Password',
        developer_personal_page_personal_profile_confirmPassword: 'Confirm New Password',


        developer_personal_page_personal_reset_password_cancel: 'Cancel',
        developer_personal_page_personal_reset_password_set_new_password: 'Set New Password',
        developer_personal_page_personal_reset_password_header: 'Change Password',
        developer_personal_page_personal_reset_password_new_password: 'New Password',
        developer_personal_page_personal_reset_password_confirm_new_password: 'Confirm New Password',
        dev_password_reset_success_title : 'Success',
        dev_password_reset_error_title : 'Error',
        developer_personal_page_personal_reset_placeholder_New_Password : "Enter New Password",

        dev_password_reset_success_modal_text : "Your password was successfully updated. You'll be prompted to enter it next time you log in.",
        dev_password_reset_error_modal_text : "The new password must not be the same as the current password or any of the previous 2 passwords.",

        developer_personal_page_personal_profile_name_validation : "The {field} can contain only alphabets",
        developer_personal_page_personal_profile_phone_number_validation : "The {field} can contain only numeric value"

    }
}
